import {get, post} from '../interceptor'

let preUrl = '/energyCount';

export default {
  getEnergyCount (params) { return post(preUrl, '/getEnergyCount', params); },
  getItemCount (params) { return post(preUrl, '/getItemCount', params); }
}



// WEBPACK FOOTER //
// ./src/api/energy/energyCount.js